import { withRouter } from 'next/router';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from '../../../routes';
import { getBlogLocales } from '../../../utils/locales';
import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';

import FlexBox from '../../../components/FlexBox';
import Main from './index';

const SubHeader = styled(FlexBox)`
  background: #333 url(${require('../../../components/Blog/SubHeader/blog-inner-bg.jpg')}) no-repeat center;
  white-space: normal;

  > div {
    padding: 38px 19px;

    a {
      color: inherit;
      text-decoration: none;
    }

    .title {
      font-size: 20px;
      line-height: 20px;
      margin-bottom: 14px;
      color: #f0b90b;
      .header-link {
        display: inline-block;
        transition: all .2s ease;
        &:hover {
          color: #DCA90A;
        }
      }
    }

    .desc {
      font-size: 16px;
      line-height: 20px;
      color: #fff;
      opacity: 0.8;
    }
  }
`;

export default
@withI18n('blog')
@withRouter
class Header extends PureComponent {
  static propTypes = {
    i18n: PropTypes.object,
    locale: PropTypes.string.isRequired,
    locales: PropTypes.array,
    router: PropTypes.object,
  };

  static defaultProps = {
    i18n: {},
    locales: [],
    router: { asPath: '/' },
  };

  _getLocales = () => {
    let resObj = {};
    const { locales } = this.props;
    const allLocales = getBlogLocales();
    locales.forEach(v => {
      resObj[v] = allLocales[v];
    });
    if (Object.keys(resObj).length === 0) {
      resObj = allLocales;
    }
    return resObj;
  };

  render() {
    const {
      i18n, locale,
    } = this.props;
    const LOCALES = this._getLocales();
    return (
      <div>
        <Main locales={LOCALES} />
        <SubHeader>
          <div>
            <div className="title">
              <Link to={`/${locale}/blog`}><a className="header-link">{getLabel('exchange-blog-header-binanceBlog', i18n)}</a></Link>
            </div>
            <div className="desc">
              {getLabel('exchange-blog-header-BlogMeaning', i18n)}
            </div>
          </div>
        </SubHeader>
      </div>
    );
  }
}
